<template>
    <span>
        <v-dialog
                :value.sync="dialog"
                :fullscreen="fullscreen"
                transition="dialog-bottom-transition"
                :overlay="false"
                :persistent="true"
                max-width="600px"
                scrollable
                style="display: inline;"
        >
            <v-card tile>
                <v-toolbar card>
                    <v-btn icon @click.native="close" :disabled="closeDisabled">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title v-text="title"></v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-tooltip :top="!fullscreen" :bottom="fullscreen" v-if="downloadLink && !$isIOS">
                        <v-btn slot="activator" @click="download" icon><v-icon>save_alt</v-icon></v-btn>
                        <span v-t="'download'"></span>
                    </v-tooltip>

                    <v-toolbar-items>
                        <v-btn v-if="confirm" :disabled="confirmDisabled" @click="$emit('ok')" flat v-t="confirmLabel"></v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text style="height: 100%">
                    <slot name="content" v-if="dialog"></slot>
                </v-card-text>
            </v-card>
        </v-dialog>

        <span ref="activator">
            <slot name="activator"></slot>
        </span>
    </span>
</template>

<script>
    export default {
        props: {
            title: {
                type: String,
                default: ''
            },
            fullscreen: {
                type: Boolean,
                default: false
            },
            fullHeight: {
                type: Boolean,
                default: false
            },
            value: {
                type: Boolean,
                default: false
            },
            confirm: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            confirmDisabled: {
                type: Boolean,
                default: false
            },
            confirmLabel: {
                type: String,
                default: 'add'
            },
            closeDisabled: {
                type: Boolean,
                default: false
            },
            downloadLink: {
                type: String,
                default: null
            },
            documentName: {
                type: String,
                default: 'Document.pdf'
            }
        },
        data: () => ({
            dialog: false
        }),
        watch: {
            value() {
                this.dialog = this.value;
            },
            dialog() {
                this.$emit('update:value', this.dialog);
            }
        },
        mounted() {
            this.dialog = this.value;

            if (this.$refs.activator.children.length > 0) {
                this.$refs.activator.children[0].onclick = (e) => {
                    if (this.disabled) {
                        return;
                    }

                    e.preventDefault();
                    e.stopPropagation();
                    this.dialog = true;
                };
            }
        },
        methods: {
            close() {
                this.dialog = false;
                this.$emit('close');
            },
            download() {
                axios({
                    url: this.downloadLink,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.documentName);
                    document.body.appendChild(link);
                    link.click();
                });
            }
        }
    }
</script>